import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.span`
	font-size: 0.8em;
	font-family: fixed;
`;

/**
 * Renders the orbital regime of a given RSO in a short manner for display.
 */
const RSOOrbitDetail = ({ periapsis, apoapsis, inclination }) => {
	return (
		<Wrapper>
			{periapsis} * {apoapsis} km {inclination}&#176;
		</Wrapper>
	);
};

RSOOrbitDetail.propTypes = {
	periapsis: PropTypes.number,
	apoapsis: PropTypes.number,
	period: PropTypes.number,
};

export default RSOOrbitDetail;
